import { Live } from "@/app/entities/Live";
import { useIsHovered } from "@/app/hooks/useIsHovered";
import { useLiveMutations } from "@/app/hooks/useLiveMutations";
import { withCdn } from "@/app/utils/withCdn";
import { Button } from "@/view/components/ui/button";
import { Card, CardContent } from "@/view/components/ui/card";
import { ptBR } from "date-fns/locale";
import { ChevronRight, Edit2Icon, Trash2Icon } from "lucide-react";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { useLiveFormContext } from "../../providers/LiveFormProvider";
import { formatInTimeZone } from "date-fns-tz";

import { PARTNER_LOGO } from "@/app/utils/getPartnerLogo";
import { twMerge } from "tailwind-merge";

interface LiveCardProps {
  live: Live;
}


export const LiveCard = ({ live }: LiveCardProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const isHovered = useIsHovered(ref);
  const { setIsLiveModalOpen, setSelectedLive } = useLiveFormContext();
  const { deleteLive } = useLiveMutations();

  const formattedDate = formatInTimeZone(
    live?.nextDate,
    "America/Sao_Paulo",
    "EEEE', 'dd' de 'MMMM', às 'HH:mm'H'",
    { locale: ptBR },
  );

  const handleDeleteLive = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    deleteLive.mutateAsync(live._id);
  };

  const handleEditLive = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setSelectedLive(live);
    setIsLiveModalOpen(true);
  };

  return (
    <Card className="border bg-transparent p-4" ref={ref}>
      <CardContent className="relative p-0">
        {isHovered && (
          <div className="absolute right-2 top-2">
            <Button
              size="icon"
              variant="outline"
              onClick={handleEditLive}
              className="mr-1 h-8 w-8"
            >
              <Edit2Icon className="h-4 w-4" />
            </Button>
            <Button
              size="icon"
              variant="destructive"
              onClick={handleDeleteLive}
              className="h-8 w-8"
            >
              <Trash2Icon className="h-4 w-4" />
            </Button>
          </div>
        )}
        <img
          alt={live.title}
          src={live.thumbnail_url ? withCdn(live.thumbnail_url) : PARTNER_LOGO}
          className={twMerge(
            "h-28 max-h-28 w-full max-w-[269px] overflow-hidden rounded-lg object-cover",
            !live.thumbnail_url && "contrast-50",
          )}
        />
        <h1 className="mt-2 text-sm font-semibold">{live.title}</h1>
        <p className="text-xs">{formattedDate} (BRT)</p>

        <Button
          className="hover: mt-2 flex w-full justify-between bg-[#E5E5E5] hover:bg-[#E5E5E5/40]"
          asChild
        >
          <Link to={live?.link}>
            <p className="max-w-36 overflow-hidden text-ellipsis text-xs text-secondary">
              {live?.link}
            </p>
            <div className="flex items-center font-semibold text-primary">
              Entrar
              <ChevronRight className="ml-1" />
            </div>
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
};
